import React, { useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import components from '../../components';
import { Link,Outlet,useNavigate, useLocation } from 'react-router-dom';

const CheckDataUnitbyType = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const[ButData,setButData]=useState({
     SDL:"" ,
     Instrumente:"",
     TimeModus:"",
     Market:"",
     Time:""
})
const handleChange = (event) => {
     setButData({...ButData,[event.target.name]: event.target.value,});
};
    console.log('location', location)
    
  return (
    <>
     {location.pathname=="/admin-panel/CheckProviderDetail/RegisterNewDataProvider"||location.pathname=="/admin-panel/CheckProviderDetail/PermissionsDetail"? <Outlet />:<div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>Provider Data Unit Detail</span> 
   {/* <Button onClick={()=>{
    navigate('/admin-panel/CheckProviderDetail/RegisterNewDataProvider');
   }}  variant="contained">Register New Data Provider</Button>  */}
    </div>     
   

     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                            <div style={{width:"95%",padding:27}} className='ProviderTitle'>
                                {/* <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
                                    <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                                        <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Provider Address</span>
                                    </div>
                                        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:10}}>
                                        <TextField style={{width:"100%"}} id="outlined-basic" label="Enter Provider Address" variant="outlined" />
                                        <div >
                                        <Button style={{paddingLeft:25,paddingRight:25,paddingTop:10,paddingBottom:10,marginLeft:10}} variant="contained">Check</Button>    
                                        </div>
                                        </div>
                                </div> */}
                            
                            <FormControl style={{width:"30%"}} >
                                                  <InputLabel id="demo-simple-select-label">Select Data Unit Type</InputLabel>
                                                  <Select
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  name='SDL'
                                                  value={ButData.SDL}
                                                  label="Select Data Unit Type"
                                                  onChange={handleChange}
                                                  >
                                                            <MenuItem value="Option 1">Unselect</MenuItem>
                                                            <MenuItem value="Option 1">king</MenuItem>
                                                            <MenuItem value="Option 2">Thermodynamixs</MenuItem>
                                                            <MenuItem value="Option 3">union</MenuItem>
                                                       </Select>
                                                       </FormControl>
                              

                            </div>
                            <div style={{width:"98%",marginTop:40}}>
                                <components.Table.CheckDataUnitbyTypeTaable/>    
                            </div>  
                            
            </div>
         
</div>}
</>
  )
}

export default CheckDataUnitbyType